import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'home',
        component: () => import('@/views/Intro'),
    },
    {
        path: '/spelen',
        name: 'quiz',
        component: () => import('@/views/Quiz'),
    },
    {
        path: '/jij-bent',
        name: 'outro',
        component: () => import('@/views/Outro'),
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

export default router;
